<template lang="pug">
  #users-menu
    md-tabs(:md-active-tab="activeTab")
      md-tab(id="tab-users" md-label="Пользователи" v-bind:to="{ name: 'Users'}")
      md-tab(id="tab-groups" md-label="Группы" v-bind:to="{ name: 'UserGroups'}")
      md-tab(id="tab-modules" md-label="Права" v-bind:to="{ name: 'UserModules'}")
</template>

<script>
  export default {
    name: 'user-menu',
    data() {
      return {
        title: '',
        activeTab: ''
      }
    },
    watch: {
      '$route'() {
        this.activeTab = 'tab-' + this.$route.meta.tab;
      },
    },
    computed: {},
    created() {
      this.activeTab = 'tab-' + this.$route.meta.tab;
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// menu.vue?7af23c0b